"use client";

import { useMenubarStore, useMenubarStoreProps } from "../__chunks/UZXETJJN.js";
import "../__chunks/OIB4PV4M.js";
import "../__chunks/QZUWIJQN.js";
import "../__chunks/CTKPPFRS.js";
import "../__chunks/HNHAUIIY.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/menu/menu-bar-store.ts
import { useEffect } from "react";
function useMenuBarStoreProps(store, update, props) {
  return useMenubarStoreProps(store, update, props);
}
function useMenuBarStore() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  useEffect(function () {
    if (process.env.NODE_ENV !== "production") {
      console.warn("useMenuBarStore is deprecated. Use useMenubarStore instead.", "See https://ariakit.org/reference/use-menubar-store");
    }
  }, []);
  return useMenubarStore(props);
}
export { useMenuBarStore, useMenuBarStoreProps };